/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin, iamUtils } from '../main';
import { iamLocalization } from '../localization';
import { WidgetElements } from '../elements/widget-elements-base';
import { iam } from '../iam';

export class EnrollTotpWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override initialize() {
    if (iam.settings.debug) console.log('initializing otp enroll widget');
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    // --- this wasn't in the old initialize widget function. it was in the getWidgetContextConfig function. seems weird so combining with the rest, but maybe there was a reason???
    // some of the enrollment options have radio buttons for iphone and android - make them appear in our style
    this.elements.getFieldsetContainer().querySelectorAll<HTMLElement>('.custom-radio > label').forEach(radioLabel => {
      const radio = radioLabel.parentElement;
      if (!radio.querySelector('span.lsg-blue-dot')) {
        // haven't already created the lsg style buttons
        radio.classList.add('lsg-radio-btn');
        const spanOut = document.createElement('span');
        spanOut.addEventListener('click', () => {
          radioLabel.click();
        });
        const spanIn = document.createElement('span');
        spanIn.className = 'lsg-blue-dot';
        spanOut.appendChild(spanIn);
        radio.insertBefore(spanOut, radioLabel);
      }
    });
    // --- end of the above section
    iamLogin.registerLocalizationCallback(() => {
      iamLogin.localizeElement('sub-header', 'otpAppSetup');
    }, true, true);
    const downloadInstructions = document.querySelector('.app-download-instructions');
    if (downloadInstructions) {
      (new MutationObserver((mutationList, observer) => {
        for (let i = 0; i < mutationList.length; i++) {
          for (let j = 0; j < mutationList[i].addedNodes.length; j++) {
            if (mutationList[i].addedNodes[j] instanceof Element) {
              // the instruction field is added when thea radio button is clicked, and then we change it from google auth to our generic otp text/link
              const addedNode = mutationList[i].addedNodes[j] as Element;
              if (addedNode.tagName === 'P') {
                const android = (document.forms[0].elements.namedItem(document.querySelector<HTMLInputElement>('input[type=radio]').name) as RadioNodeList).value === 'ANDROID';
                iamLogin.localizeElement(addedNode, {
                  stringKey: android ? 'otpAppDownloadAndroid' : 'otpAppDownloadIos',
                  stringParameters: {
                    startLink: `<a target="_blank" href="${android ? 'https://play.google.com/store/search?q=2fa&c=apps' : `https://www.apple.com/${iamLocalization.getLocale()?.split('_')[1]?.toLowerCase() ?? 'us'}/search/2fa?src=globalnav`}">`,
                    endLink: '</a>'
                  },
                  rawHTML: true
                });
                return;
              }
            }
          }
        }
      })).observe(downloadInstructions, { childList: true });
    }
    iamLogin.page.showCommonFields(['auth-footer']);
    iamLogin.page.initializeCommon();
  }
}
